import React from 'react';

function ValidationMessage(props) {
  const { isValid, text } = props;
  if (!isValid) {
    return <div />;
  }

  return <h6 className="red-text">{text}</h6>;
}

export default ValidationMessage;
